import React from 'react';
import Autopara from './Autopara';

const images = [
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJoqBuMDSvc57IYGrfWprBuBLCGzFox8RCkQ&s',
  'https://img.freepik.com/premium-photo/python-language-logo-with-snake-wrapped-around-it-blue-background_1294789-18567.jpg',
  'https://funender.com/wp-content/uploads/2019/04/Features-of-python.jpg',
];

const paragraphText = `
  Python is a versatile, high-level programming language known for its readability and broad library support. 
  It is widely used in web development, data science, AI, machine learning, automation, and more. 
  With frameworks like Django and Flask, Python simplifies building robust backends. 
  Its clear syntax makes it ideal for beginners and professionals alike.
`;

function AutoparaPython() {
  return <Autopara images={images} text={paragraphText} />;
}

export default AutoparaPython;
